export { createDeepSeek, deepseek } from './deepseek-provider';
export type {
  DeepSeekProvider,
  DeepSeekProviderSettings,
} from './deepseek-provider';
export type { OpenAICompatibleErrorData as DeepSeekErrorData } from '@ai-toolkit/openai-compatible';
